import { presetPalettes } from "@ant-design/colors";

import { statusColors } from "../constants/colors";

export function statusColor(status: string) {
  return statusColors[status as keyof typeof statusColors] || statusColors.new;
}

const colorPallets = [
  presetPalettes.orange,
  presetPalettes.cyan,
  presetPalettes.lime,
  presetPalettes.blue,
  presetPalettes.blue,
  presetPalettes.magenta,
];

export function formatRandomColor(index: number | string, depth = 3) {
  const idx = Number.parseInt(index.toString());
  return colorPallets[idx % colorPallets.length][depth];
}
